import { Injectable } from '@angular/core';

import { SpaContext } from '../../../../Classes/spacontext';
import { VisibaApiHttp } from '../../../../Classes/visibaHttp.class';
import { PaymentServiceApiModel } from '../Models/PaymentServiceApiModel';

@Injectable()
export class PaymentServiceV2 {
	readonly baseUri = '/api/Client/v2/Units/';

	constructor(
		private http: VisibaApiHttp,
		public spaContext: SpaContext,
	) {}

	public get(billId: number | string) {
		return this.http.getTyped<PaymentServiceApiModel[]>(
			`${this.baseUri}${this.spaContext.unitConfig.Unit.UnitId}/Payments/${billId}/Services`,
			true,
		);
	}
}
